// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__UJCQm","xlSpinner":"Spinner_xlSpinner__qFGtP","wrapper":"Spinner_wrapper__-b0ny"};